import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const drawerWidth = '90%';
const drawerMaxWidth = '450px';

const useStyles = makeStyles(() =>
  createStyles({
    headerStyles: {
      display: 'flex',
      width: '100%',
      height: 70,
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0px 20px',
      backgroundColor: `${theme.palette.primary.main}`,
      '& .MuiLink-underlineHover': {
        textDecoration: 'none',
      },

      [theme.breakpoints.up('sm')]: {
        height: 95,
        padding: 0,
      },
    },
    nested: {
      paddingLeft: 60,
    },
    imageBox: {
      width: 35,
      height: 35,
      borderRadius: 8,

      backgroundColor: theme.palette.primary.light,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      [theme.breakpoints.up('sm')]: {
        width: 48,
        height: 48,
      },
    },
    iconMobile: {
      width: 35,
      height: 35,
      marginLeft: 2,
    },
    iconMobileWrap: {
      backgroundColor: 'rgba(179, 145, 227, 0.25)',
      filter: 'brightness(0.8)',
      borderRadius: 8,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      width: 35,
      height: 35,
      marginLeft: 2,
    },
    menuDrop: {
      marginTop: 95,
      backgroundColor: 'rgba(0,0,0, 0.4)',
      '& .MuiPaper-root': {
        borderRadius: 12,
        padding: '20px',
        position: 'relative',
        maxWidth: 750,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '30px 0 0',
      },
      '&:after': {
        content: '" "',
        position: 'absolute',
        top: 50,
        left: '60%',
        width: 0,
        height: 0,
        border: '20px solid transparent',
        borderBottomColor: '#fff',
        borderTop: 0,
        marginLeft: -20,
        marginTop: -20,
      },
    },
    box: {
      display: 'flex',
      padding: 10,
      justifyContent: 'space-between',
      alignItems: 'center',
      maxWidth: 1080,
      '& .MuiIconButton-root': {
        position: 'absolute',
        top: 10,
        right: 20,

        [theme.breakpoints.up('sm')]: {
          top: 25,
          right: 27,
        },
      },
      '& a': {
        cursor: 'pointer',
      },
    },
    logo: {
      width: '120px',
      color: theme.palette.primary.main,
      [theme.breakpoints.up('sm')]: {
        width: '150px',
      },
    },
    menu: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    closeDrawer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 95,
    },
    closeDrawerButton: {
      position: 'absolute',
      top: 25,
      right: 27,
    },
    ourAppsWebBtn: {
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    menuItem: {
      color: 'white',
      textDecoration: 'none',
      fontSize: 14,
      fontWeight: 700,
      marginRight: 20,
      textTransform: 'none',
      cursor: 'pointer',
      [theme.breakpoints.up('md')]: {
        marginRight: 24,
      },
    },

    gridMenuItem: {
      width: '100%',
      borderRadius: 5,
      textAlign: 'start',
      padding: '10px 5px',
      fontSize: 20,
      marginLeft: 20,
      '&:hover': {
        backgroundColor: 'rgba(179, 145, 227, 0.1)',
        borderRadius: 8,
      },
    },
    iconGridMenuItem: {
      marginRight: 10,
      '& img': {
        height: '1rem',
      },
    },
    iconOurAppsWeb: {
      width: 48,
      height: 48,
      backgroundColor: 'rgba(179, 145, 227, 0.25)',
      filter: 'brightness(0.8)',
      borderRadius: 8,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
    },
    drawer: {
      width: drawerWidth,
      maxWidth: drawerMaxWidth,
      flexShrink: 0,
      '& hr': {
        height: 1.5,
        backgroundColor: theme.palette.grey[300],
        opacity: 0.06,
      },
    },
    drawerPaper: {
      width: drawerWidth,
      maxWidth: drawerMaxWidth,
      padding: 10,
    },
    ajustLayoutDrawerMenu: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '100%',
      position: 'relative',
      padding: '60px 0 10vh',

      '& .MuiTypography-body2': {
        maxWidth: 237,
        color: theme.palette.grey[300],
        textAlign: 'center',
      },
    },
    socialMedia: {
      margin: '0 auto',
      '& svg': {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.secondary.light,
        height: 40,
        width: 40,
        padding: 10,
        borderRadius: 12,
      },
      '& button': {
        '& + button': {
          marginLeft: 10,
        },
        '&:hover': {
          filter: 'brightness(0.8)',
        },
      },
    },
    hide: {
      display: 'none',
    },
    menuDrawer: {
      display: 'inline',
    },
    menuItemDrawer: {
      // width: '0%',
      textDecoration: 'none',
      fontSize: 14,
      '& .MuiTypography-body1, > svg': {
        color: 'rgba(119, 128, 160, 1)',
        fontWeight: 700,
      },
    },

    followDrawer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    languageMenu: {
      width: 200,
      margin: '0 auto',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',

      '& button': {
        color: theme.palette.grey[300],
        textTransform: 'capitalize',
      },
    },

    icons: {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.secondary.light,
      fontSize: 23,
      borderRadius: '50%',
      border: '1.5px solid',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    copyright: {
      fontSize: 12,
    },
  }),
);

export default useStyles;
